import React, { VFC } from 'react';

import CustomButton from '@/components/CustomButton';
import { getEtherscanTransactionLink } from '@/utils/etherscan';

import styles from './SwapWithIPFSCompletedContent.module.scss';
// Add whatever to display
type Props = {
  swappedTokenCount: number;
  lastTransactionHash?: string;
  onCloseButtonClick(): void;
};

// TODO: Determine what to display and design
const SwapWithIPFSCompletedContent: VFC<Props> = ({
  swappedTokenCount,
  lastTransactionHash,
  onCloseButtonClick,
}: Props) => {
  return (
    <div className={styles.swapWithIPFSCompleted}>
      <p>Completed swapping {swappedTokenCount} tokens!</p>

      {lastTransactionHash ? (
        <p>
          Transaction Hash: {lastTransactionHash}
          <a
            href={getEtherscanTransactionLink(lastTransactionHash)}
            target="_blank"
            rel="noreferrer"
          >
            View on Etherscan
          </a>
        </p>
      ) : null}
      <CustomButton variant="primary" onClick={onCloseButtonClick}>
        Got it!
      </CustomButton>
    </div>
  );
};

export default SwapWithIPFSCompletedContent;
